import { PaginatedResponse } from './index';

export interface LeadTagBase {
  name: string;
  color: string;
  description?: string | null;
}

export interface LeadTagResponse extends LeadTagBase {
  id: string;
  tenant_id: string;
  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
  is_deleted: boolean;
}

export interface LeadTagCreate {
  name: string;
  color?: string;
  description?: string;
}

export interface LeadTagUpdate {
  name?: string;
  color?: string;
  description?: string;
}

export interface LeadTagListResponse extends PaginatedResponse<LeadTagResponse> {}

export interface LeadTagAttachRequest {
  tag_id: string;
}

export interface LeadTagAttachResponse {
  success: boolean;
  lead_id: string;
  tag_id: string;
}

export const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export const DEFAULT_TAG_COLOR = '#6b7280';

export const TAG_PALETTE: string[] = [
  '#ef4444',
  '#f97316',
  '#f59e0b',
  '#eab308',
  '#84cc16',
  '#22c55e',
  '#10b981',
  '#14b8a6',
  '#06b6d4',
  '#3b82f6',
  '#6366f1',
  '#8b5cf6',
  '#a855f7',
  '#ec4899',
  '#6b7280',
];
